"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CommentsController", {
    enumerable: true,
    get: function() {
        return CommentsController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _PagedResponse = require("~/helpers/PagedResponse");
const _commentsservice = require("~/services/comments.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let CommentsController = class CommentsController {
    async commentList(context, req) {
        return new _PagedResponse.PagedResponseImpl(await this.commentsService.commentList(context, {
            query: req.query
        }));
    }
    async commentRow(context, req, body) {
        return await this.commentsService.commentRow(context, {
            user: req.user,
            body: body,
            req
        });
    }
    async commentDelete(context, req, commentId) {
        return await this.commentsService.commentDelete(context, {
            commentId,
            user: req.user,
            req
        });
    }
    async commentUpdate(context, commentId, req, body) {
        return await this.commentsService.commentUpdate(context, {
            commentId: commentId,
            user: req.user,
            body: body,
            req
        });
    }
    async commentsCount(context, fk_model_id, ids) {
        return await this.commentsService.commentsCount(context, {
            fk_model_id,
            ids
        });
    }
    constructor(commentsService){
        this.commentsService = commentsService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/comments',
        '/api/v2/meta/comments'
    ]),
    (0, _extractidsmiddleware.Acl)('commentList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], CommentsController.prototype, "commentList", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/comments',
        '/api/v2/meta/comments'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('commentRow'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], CommentsController.prototype, "commentRow", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/comment/:commentId',
        '/api/v2/meta/comment/:commentId'
    ]),
    (0, _extractidsmiddleware.Acl)('commentDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('commentId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], CommentsController.prototype, "commentDelete", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/comment/:commentId',
        '/api/v2/meta/comment/:commentId'
    ]),
    (0, _extractidsmiddleware.Acl)('commentUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('commentId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], CommentsController.prototype, "commentUpdate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/comments/count',
        '/api/v2/meta/comments/count'
    ]),
    (0, _extractidsmiddleware.Acl)('commentCount'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Query)('fk_model_id')),
    _ts_param(2, (0, _common.Query)('ids')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Array
    ]),
    _ts_metadata("design:returntype", Promise)
], CommentsController.prototype, "commentsCount", null);
CommentsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _commentsservice.CommentsService === "undefined" ? Object : _commentsservice.CommentsService
    ])
], CommentsController);
